import { createFileRoute } from "@tanstack/react-router";
import { listBlogArticles } from "../lib/blog.functions";
import { BlogIndexPage } from "../components/blog-index";
import { getLocale, blogIndexAltLinks, scriptFontLinks } from "../lib/blog-locales";

const SITE = "https://capitalpropressurewashing.com";
const LOCALE = getLocale("ar");
const TITLE = `${LOCALE.ui.blogTitle} | Capital Pro Pressure Washing`;
const DESC = LOCALE.ui.blogIntro;

export const Route = createFileRoute("/ar/blog")({
  loader: async () => ({
    articles: await listBlogArticles({ data: { language: "ar" } }),
  }),
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "website" },
      { property: "og:url", content: `${SITE}/ar/blog` },
      { property: "og:locale", content: LOCALE.ogLocale },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: DESC },
    ],
    links: [
      { rel: "canonical", href: `${SITE}/ar/blog` },
      ...blogIndexAltLinks(SITE),
      ...scriptFontLinks(LOCALE.code),
    ],
  }),
  component: BlogIndexAr,
  errorComponent: () => (
    <main className="mx-auto max-w-[1200px] px-4 py-12">
      <p className="text-[var(--brand-charcoal)]/70">{LOCALE.ui.loadError}</p>
    </main>
  ),
  notFoundComponent: () => (
    <main className="mx-auto max-w-[1200px] px-4 py-12">
      <p className="text-[var(--brand-charcoal)]/70">{LOCALE.ui.noArticles}</p>
    </main>
  ),
});

function BlogIndexAr() {
  const { articles } = Route.useLoaderData();
  return <BlogIndexPage articles={articles} locale={LOCALE} />;
}
